import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import styles from "standard.module.scss";

import { ReportItem } from "pages/photo/types";

const useStyles = makeStyles((theme) => ({
  card: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(1.6),
    borderRadius: "8px",
    border: `1px solid ${theme.palette.grey[300]}`,
    backgroundColor: "#fff",
    cursor: "pointer",
    marginBottom: theme.spacing(1),
    position: "relative",
    transition: "box-shadow 0.2s",
    boxShadow: styles.boxShadowSoftElevation
  },
  content: {
    flex: 1
  },
  titleArea: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },
  title: {
    fontWeight: 700,
    fontSize: "1.25rem",
    color: "#0E2E3A"
  },
  subtitle: {
    fontSize: "0.8125rem",
    color: "#495459",
    marginTop: theme.spacing(0.4)
  },
  bullet: {
    color: "#06668C"
  },
  badge: {
    backgroundColor: "#0E2E3A",
    color: "#fff",
    borderRadius: "8px",
    padding: `${theme.spacing(0.6)}px ${theme.spacing(0.8)}px`,
    fontSize: "0.8125rem",
    fontWeight: 400,
    whiteSpace: "nowrap",
    alignSelf: "flex-start",
    marginTop: theme.spacing(0.2)
  },
  chevron: {
    display: "flex",
    alignItems: "center",
    color: "#495459",
    width: 24,
    height: 24
  }
}));

type Props = {
  reportItem: ReportItem;
  onClick: () => void;
};

export default function ReportOverviewCard({ reportItem, onClick }: Props) {
  const classes = useStyles();
  const { category, totalQuantity, groups } = reportItem;

  const breakdownLines =
    groups.length > 0
      ? groups.map((g) => ({
          brand: g.brand.label || "Unknown",
          material: g.material.label,
          quantity: g.quantity
        }))
      : null;

  return (
    <div className={classes.card} onClick={onClick}>
      <div className={classes.content}>
        <div className={classes.titleArea}>
          <span className={classes.badge}>{totalQuantity}&times;</span>
          <Typography className={classes.title}>{category.label}</Typography>
        </div>
        {breakdownLines ? (
          breakdownLines.map((line, i) => (
            <Typography key={i} className={classes.subtitle}>
              {`${line.quantity}\u00d7 `}
              {line.brand}
              {line.material ? (
                <>
                  <span className={classes.bullet}>{" \u2022 "}</span>
                  {line.material}
                </>
              ) : null}
            </Typography>
          ))
        ) : (
          <Typography className={classes.subtitle}>
            Tap to add item details
          </Typography>
        )}
      </div>
      <div className={classes.chevron}>
        <ChevronRightIcon />
      </div>
    </div>
  );
}
